module.exports = __webpack_public_path__ + "static/img/coach.56d3b60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/coach.png
// module id = 0aqE
// module chunks = 110